///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { GtthSharedModule } from '../shared/shared.module';
import { HOME_ROUTE } from './home.route';
import { HomeComponent } from './home.component';

@NgModule({
    imports: [GtthSharedModule, RouterModule.forChild([HOME_ROUTE])],
    declarations: [HomeComponent],
    providers: [],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class GtthHomeModule {}
